import { injectable } from 'inversify'
import type { RouteRecordRaw } from 'vue-router'
import type RouterBuilderMiddlewareInterface from '@/services/route/routerBuilderMiddleware/types'
import type { AppModule } from '@/config/types'
import { serviceToModuleMap } from '@/core/container/serviceModuleRegistry'
import type { ResolverConfig } from '@/services/types'

@injectable()
export default class ModulesRouterBuilderMiddleware implements RouterBuilderMiddlewareInterface {
  public pipe(routes: RouteRecordRaw[]): RouteRecordRaw[] {
    this.addModulesToRoute(routes)
    return routes
  }

  private addModules(route: RouteRecordRaw, extra: AppModule[]) {
    if (!route.meta) {
      route.meta = {}
    }
    if (!route.meta.modules) {
      route.meta.modules = [...extra]
    } else {
      for (const mod of extra) {
        if (!route.meta.modules.includes(mod)) {
          route.meta.modules.push(mod)
        }
      }
    }
  }

  private addModulesToRoute(routes: RouteRecordRaw[], modules: AppModule[] = []) {
    for (const route of routes) {
      if (modules.length) {
        this.addModules(route, modules)
      }

      this.addResolverModules(route)
      if (route.children?.length) {
        this.addModulesToRoute(route.children, route.meta?.modules ?? [])
      }
    }
  }

  private addResolverModules(route: RouteRecordRaw) {
    const resolvers = route.meta?.resolvers
    if (!resolvers?.length) {
      return
    }

    const existingModules = route.meta?.modules ?? []
    const modules: AppModule[] = []
    for (const item of resolvers) {
      const configs: ResolverConfig[] = Array.isArray(item) ? item : [item]
      for (const config of configs) {
        const module = serviceToModuleMap.get(config.service)
        if (module && !existingModules.includes(module) && !modules.includes(module)) {
          // eslint-disable-next-line no-console
          // console.warn(
          //   `The "${config.service}" resolver was defined for the route "${String(route.name)}" that implicitly depends on "${module}". Adding the module to route deps…`,
          // )
          modules.push(module)
        }
      }
    }

    if (modules.length) {
      this.addModules(route, modules)
    }
  }
}
